import { Spacing, useNotifications } from '@doveit/bricks';
import React from 'react';
import Divider from '../../../components/divider/Divider';
import SelectContact from '../../../contact/containers/select-contact/SelectContact';
import createOrUpdateContact from '../../../contact/utils/createOrUpdateContact';
import { Contact, PropertyContactReference } from '../../../providers/api/dtos';
import { createPropertyContact } from '../../../providers/api/property-contact/propertyContactProvider';
import PropertyContactForm, { PropertyContactFormModel } from '../../components/property-contact-form/PropertyContactForm';
import { ContactStatus } from '../../../contact/containers/select-contact/types';

export interface CreatePropertyContactProps {
  propertyId: number,
  onSuccess?: (propertyContactReference: PropertyContactReference) => void,
}

export const CREATE_PROPERTY_CONTACT_SUCCESS_MESSAGE = 'Il referente è stato aggiunto con successo';
export const CREATE_PROPERTY_CONTACT_ERROR_MESSAGE = 'Non è stato possibile aggiungere il referente';

const CreatePropertyContact: React.FC<CreatePropertyContactProps> = ({
  propertyId,
  onSuccess,
}) => {
  const [isSaving, setIsSaving] = React.useState(false);
  const { addSuccess, addError } = useNotifications();
  const [selectedContact, setSelectedContact] = React.useState<Contact | undefined>();
  const [overwriteValues, setOverwriteValues] = React.useState<Partial<Contact> | undefined>();
  const [hasDuplicateContact, setHasDuplicateContact] = React.useState(false);

  const onContactChange = React.useCallback((status: ContactStatus, contactData?: Contact, search?: Partial<Contact>) => {
    setSelectedContact(contactData);
    setOverwriteValues(search);
    setHasDuplicateContact(status === 'DUPLICATE');
  }, [setHasDuplicateContact]);

  const onSubmit = React.useCallback(async (values: PropertyContactFormModel) => {
    setIsSaving(true);

    try {
      const contact = await createOrUpdateContact(overwriteValues, selectedContact);

      const propertyContactReference = await createPropertyContact({
        contactId: contact.id!,
        propertyId,
        relationship: values.relationship,
      });

      setIsSaving(false);
      addSuccess(CREATE_PROPERTY_CONTACT_SUCCESS_MESSAGE);

      if (onSuccess) {
        onSuccess(propertyContactReference);
      }
    } catch (error) {
      setIsSaving(false);
      addError(CREATE_PROPERTY_CONTACT_ERROR_MESSAGE);
    }
  }, [addError, addSuccess, onSuccess, overwriteValues, propertyId, selectedContact]);

  return (
    <div>
      <Divider>Dati contatto</Divider>
      <SelectContact
        onContactChange={onContactChange}
      />
      <Spacing margin={[200, 0, 0]}>
        <PropertyContactForm
          submitLabel="Aggiungi"
          onSubmit={onSubmit}
          disabled={!(selectedContact || overwriteValues) || hasDuplicateContact}
          loading={isSaving}
        />
      </Spacing>
    </div>
  );
};

export default CreatePropertyContact;
